import { randomString } from '@fry/lib/utils';
import { BoardCardType, BoardCardJSON } from '@fry/boards/lib';

export class BoardCard {

    public id: string;

    public type: BoardCardType;

    public options: Record<string, any>;

    public get isConfigurable(): boolean {
        return !!this.type.editComponent;
    }

    public constructor(type: BoardCardType, options: Record<string, any>, id?: string) {
        this.id = id || randomString();
        this.type = type;
        this.options = options;
    }

    public toJSON(): BoardCardJSON {
        return { id: this.id, type: this.type.name, options: this.options };
    }
}